import { buildCollection } from "@firecms/core";
import uniqid from "uniqid";
import LocaleSchema from "./locale";

interface IAsset {
  custom_id: string;
  images: string[];
}

const AssetSchema = buildCollection<IAsset>({
  id: "assets",
  name: "Textos generalizados(links,etc)",
  path: "assets",
  subcollections: [LocaleSchema],
  // subcollections
  properties: {
    custom_id: {
      name: "custom_id",
      validation: { required: true, unique: true },
      dataType: "string",
      // config: {
      //   enumValues: {
      //     "logo": "Logo",
      //     "landing-photos": "Landing Photos",
      //     "landing-photos-mobile": "Landing Photos Mobile",
      //     "about-us": "About Us",
      //     "courses": "Courses",
      //     "hikes": "Hikes",
      //     "workshops": "Workshops",
      //     "landingpage-title": "Landing Page Title",
      //     "find-more": "Find more text",
      //     "description": "Description",
      //     "itinerary": "Itinerary",
      //     "head-title": "Head title",
      //     "head-description": "Head description",
      //     "other-experiences": "Other experiences",
      //   },
      // }
    },
    images: {
      name: "Images",
      dataType: "array",
      of: {
        name: "Images",
        dataType: "string",
        storage: {
          fileName: () => uniqid(),
          storagePath: "images/assets",
          acceptedFiles: ["image/*"],
          metadata: {
            cacheControl: "max-age=1000000",
          },
        },
      },
    },
  },
});

export default AssetSchema;
